<div class="modal-header">
  <h4 id="reject-review-gear-renaming-proposals-model" class="modal-title">{{ "Reject" | translate }}</h4>
  <button (click)="modal.dismiss()" class="close" aria-describedby="modal-title" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>
    {{
      "Please reject a renaming proposal only if the proposal incorrectly makes the item a different product."
        | translate
    }}
  </p>

  <p>
    {{
      "Do not let your personal preference for a naming convention be a reason for rejection at this time, as data defragmentation is more important than minor spelling concerns that can be fixed later."
        | translate
    }}
  </p>

  <p>
    {{ "Thank you!" | translate }}
  </p>

  <hr />

  <form [formGroup]="form">
    <formly-form [fields]="fields" [form]="form" [model]="model"></formly-form>
  </form>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-outline-secondary" type="button">
    {{ "Cancel" | translate }}
  </button>

  <button
    [class.loading]="loadingService.loading$ | async"
    [disabled]="!form.valid"
    (click)="reject()"
    class="btn btn-danger"
    type="button"
  >
    {{ "Reject" | translate }}
  </button>
</div>
